import { createSelector } from 'reselect';
import { getAllAssets } from 'helpers/selectors';
import { getSelectedNotification } from '../../PowertrainOverview/Header/NotificationDropdown/selectors';
import { getNameplatePicturesLoadingStatus } from '../../PowertrainAssetDetails/DetailedInformation/selectors';

const getSubscriptionStatus = ({ powertrainTools }) => {
    return powertrainTools?.subscriptionStatus?.subscriptionArr?.data?.assetSubscriptionsInfos;
};

const getSubscriptionLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.subscriptionStatus?.subscriptionArr?.loadingStatus;
};

const getNewCapability = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.newAssetCapabilityV2;
};

const getProductTypeCode = ({ assetOverviewV2 }) => {
    return assetOverviewV2?.assetOverview;
};

const getAssetOnline = ({ assetOverviewV2 }) => {
    return assetOverviewV2?.assetOverview?.dataConnectionStatus;
};

const getLastStatusChangeRecievedTimestamp = ({ assetOverviewV2 }) => {
    return assetOverviewV2?.assetOverview?.lastStatusChangeRecievedTimestamp;
};

const getConnectivityType = ({ assetOverviewV2 }) => {
    return assetOverviewV2?.assetOverview?.connectivityType;
};

const getAssetLabels = ({ assetDetailsInfoHeader }) => {
    return assetDetailsInfoHeader?.labels?.data;
};

const getAssetDetailsLabelsLoadingStatus = ({ assetDetailsInfoHeader }) => {
    return assetDetailsInfoHeader?.labels?.loadingStatus;
};

const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

const getSelectedAssetV2 = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.selectedAsset;
};

const getSmartConditionSummary = ({ assetOverviewV2 }) => {
    return assetOverviewV2?.smartConditionSummary?.smartConditionSummary;
};

export const getModel = createSelector([
    getSubscriptionStatus,
    getSubscriptionLoadingStatus,
    getAllAssets,
    getNewCapability,
    getProductTypeCode,
    getAssetOnline,
    getLastStatusChangeRecievedTimestamp,
    getConnectivityType,
    getAssetLabels,
    getAssetDetailsLabelsLoadingStatus,
    getNameplatePicturesLoadingStatus,
    getSelectedNotification,
    getSelectedAsset,
    getSelectedAssetV2,
    getSmartConditionSummary
], (
    subscriptionStatus,
    subscriptionLoadingStatus,
    allAssets,
    newSelectedAssetCapability,
    productTypeCode,
    assetOnline,
    lastStatusChangeRecievedTimestamp,
    connectivityType,
    assetLabels,
    assetDetailsLabelsLoadingStatus,
    nameplatePicturesLoadingStatus,
    selectedNotification,
    selectedAsset,
    selectedAssetV2,
    smartConditionSummary
) => {
    return {
        subscriptionStatus,
        subscriptionLoadingStatus,
        allAssets,
        newSelectedAssetCapability,
        productTypeCode,
        assetOnline,
        lastStatusChangeRecievedTimestamp,
        connectivityType,
        assetLabels,
        assetDetailsLabelsLoadingStatus,
        nameplatePicturesLoadingStatus,
        selectedNotification,
        selectedAsset,
        selectedAssetV2,
        smartConditionSummary
    };
});
